<template>
    <div class="technical">
        高德信息重视人才的培养，努力为员工提供良好的工作环境和奖励机制，给予员工充分的发挥空间来激发创造力，让员工与企业共同成长，在工作中不断实现自身价值以获得个人满足感。
    </div>
</template>
<script>
export default {
    name:'aboutTechnical',
}
</script>
<style lang="stylus" scoped>
.technical
    padding:30px;
    text-align:justify;
</style>